module.exports = __webpack_public_path__ + "media/images/profile-image-img-214a04f7eb923903f8793116abf7a8a1.png";